// 组-单个-设置
export const NEG_WORD_GROUP_SINGLE_SET = 'campaign_privative_set'
// 组-批量-追加
export const NEG_WORD_GROUP_MULTI_APPEND = 'campaign_privative_add'
// 组-批量-替换
export const NEG_WORD_GROUP_MULTI_REPLACE = 'campaign_privative_replace'
// 计划-单个-设置
export const NEG_WORD_PLAN_SINGLE_SET = 'ad_privative_add'
// 计划-批量-追加
export const NEG_WORD_PLAN_MULTI_APPEND = 'ad_privative_set'
// 计划-批量-替换
export const NEG_WORD_PLAN_MULTI_REPLACE = 'ad_privative_replace'

export const NEG_ENTITIES = {
  group: {
    name: '广告组',
    operations: [
      NEG_WORD_GROUP_SINGLE_SET,
      NEG_WORD_GROUP_MULTI_APPEND,
      NEG_WORD_GROUP_MULTI_REPLACE
    ]
  },
  plan: {
    name: '广告计划',
    operations: [
      NEG_WORD_PLAN_SINGLE_SET,
      NEG_WORD_PLAN_MULTI_APPEND,
      NEG_WORD_PLAN_MULTI_REPLACE
    ]
  }
}

export const PROCESS_EDIT = 'EDIT'
export const PROCESS_CONFIRM = 'CONFIRM'
export const PROCESS_RESULT = 'RESULT'
